<template>
  <div id="box" class="warning">
    <div class="inner">
      <div class="scrollWrapper">
        <h1 v-html="title" />
        <p v-html="description" class="description" />
        <div class="expandWrapper">
          <img
            v-svg-inline
            class="img"
            src="../assets/imgs/differentBrowser.svg"
            alt="error"
          />
        </div>
      </div>
      <CustomButton
        :buttonType="'accent'"
        :customButtonTxt="customButton"
        @submit="back"
        v-if="hasCustomButton"
      />
    </div>
  </div>
</template>

<script>
import CustomButton from "../components/customButton.vue";
export default {
  name: "MobileWarning",
  components: {
    CustomButton,
  },
  props: {
    warningType: {
      type: String,
      default: "differentBrowser",
    },
    redirectURL: {
      type: String,
      default: "",
    },
  },
  mounted() {
    localStorage.removeItem("login_challenge");
  },
  computed: {
    title() {
      return this.$t("authorizationError." + this.warningType + ".title");
    },
    description() {
      return this.$t("authorizationError." + this.warningType + ".description");
    },
    customButton() {
      return this.$t("customButton.return");
    },
    hasCustomButton() {
      switch (this.warningType) {
        case "differentBrowser":
          return false;
        default:
          return true;
      }
    },
  },
  methods: {
    back() {
      switch (this.warningType) {
        default:
          break;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
#box
  .expandWrapper
    +flex()
    .img
      +size(240px)
      overflow: hidden
  .wrapper
    +flex(space-between, center, row)
</style>